/* PDP v2 interactions (Trello #343).
   One file for the whole pdp2-* section family. Each section loads it
   with the same URL; the init guard below makes re-execution a no-op.
   Everything is feature-guarded so sections can be reordered or removed
   in the theme editor without breaking the others. */
(function () {
  'use strict';
  if (window.PDP2_INIT) return;
  window.PDP2_INIT = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollBehavior = reduceMotion ? 'auto' : 'smooth';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    /* ── Hero: gallery thumbs ─────────────────────────────── */
    var mainImg = document.getElementById('Pdp2MainImg');
    var thumbButtons = document.querySelectorAll('.pdp2-gallery-thumbs button');

    function selectThumb(btn) {
      thumbButtons.forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      if (btn) btn.setAttribute('aria-current', 'true');
    }

    thumbButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImg) return;
        selectThumb(btn);
        mainImg.src = btn.getAttribute('data-full');
        if (btn.getAttribute('data-alt')) mainImg.alt = btn.getAttribute('data-alt');
      });
    });

    /* ── Hero: recipe switcher ────────────────────────────── */
    var recipeTitle = document.getElementById('Pdp2RecipeTitle');
    document.querySelectorAll('.pdp2-recipe-thumb').forEach(function (card) {
      card.addEventListener('click', function () {
        document.querySelectorAll('.pdp2-recipe-thumb').forEach(function (c) {
          c.setAttribute('aria-pressed', 'false');
        });
        card.setAttribute('aria-pressed', 'true');
        if (recipeTitle && card.getAttribute('data-title')) {
          recipeTitle.textContent = card.getAttribute('data-title');
        }
        var img = card.getAttribute('data-img');
        if (img && mainImg) {
          mainImg.src = img;
          // When the recipe image IS one of the product's own gallery images,
          // highlight its thumbnail rather than leaving the strip with nothing
          // selected — the gallery and the switcher stay one coherent control.
          var mediaId = card.getAttribute('data-media-id');
          var match = null;
          if (mediaId) {
            thumbButtons.forEach(function (b) {
              if (b.getAttribute('data-media-id') === mediaId) match = b;
            });
          }
          selectThumb(match);
        }
      });
    });

    /* ── Hero: stars → reviews strip ──────────────────────── */
    document.querySelectorAll('.pdp2-stars-row').forEach(function (row) {
      row.addEventListener('click', function (e) {
        var target = document.querySelector('.section-prs') || document.querySelector('.pdp2-wall');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
      });
    });

    /* ── Tab groups (Recipe & Nutrition, What's Inside) ───────
       Markup contract:
         button: data-pdp2-tab-group="<group>"  data-pdp2-target="<key>"
         panel:  data-pdp2-panel-group="<group>" data-pdp2-panel="<key>"
       Several panels may share one key, so a single tab can drive both an
       accordion panel and its matching bowl image.
       Buttons use aria-selected (rn tabs) or aria-pressed (pills). */
    function activateTab(btn) {
      if (!btn) return;
      var group = btn.getAttribute('data-pdp2-tab-group');
      var attr = btn.hasAttribute('aria-selected') ? 'aria-selected' : 'aria-pressed';
      document.querySelectorAll('[data-pdp2-tab-group="' + group + '"]').forEach(function (b) {
        b.setAttribute(attr, 'false');
      });
      btn.setAttribute(attr, 'true');
      var key = btn.getAttribute('data-pdp2-target');
      document.querySelectorAll('[data-pdp2-panel-group="' + group + '"]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-pdp2-panel') !== key;
      });
    }

    document.querySelectorAll('[data-pdp2-tab-group]').forEach(function (btn) {
      btn.addEventListener('click', function () { activateTab(btn); });
    });

    /* ── Cross-section jump that carries the chosen recipe ────
       "See What's Inside" under the nutrition bowl scrolls to the
       ingredient carousel AND selects the same recipe there, so the reader
       lands on the ingredients for the recipe they were just reading. */
    document.querySelectorAll('[data-pdp2-jump]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetSel = link.getAttribute('data-pdp2-jump');
        var recipe = link.getAttribute('data-pdp2-jump-recipe');
        var target = document.querySelector(targetSel);
        if (!target) return;
        e.preventDefault();
        if (recipe) {
          // Scope the lookup to the destination section. Recipe keys are shared
          // ACROSS sections by design, so a document-wide query would find the
          // nutrition tab we are jumping FROM rather than the one we want.
          var scope = target.closest('.section-pdp2') || document;
          activateTab(scope.querySelector(
            '[data-pdp2-tab-group][data-pdp2-recipe-key="' + recipe + '"]'
          ));
        }
        target.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
      });
    });

    /* ── Ingredient carousel prev/next ────────────────────── */
    function visibleCarousel(section) {
      return section.querySelector('.pdp2-ing-carousel:not([hidden])');
    }
    document.querySelectorAll('.pdp2-ingredients').forEach(function (section) {
      var prev = section.querySelector('.pdp2-ing-nav--prev');
      var next = section.querySelector('.pdp2-ing-nav--next');
      if (prev) prev.addEventListener('click', function () {
        var c = visibleCarousel(section);
        if (c) c.scrollBy({ left: -226, behavior: scrollBehavior });
      });
      if (next) next.addEventListener('click', function () {
        var c = visibleCarousel(section);
        if (c) c.scrollBy({ left: 226, behavior: scrollBehavior });
      });
    });

    /* ── Feeding calculator ───────────────────────────────── */
    var calc = document.querySelector('.pdp2-calc-widget');
    if (calc) {
      var weightInput = calc.querySelector('.pdp2-fc-input');
      var puppyCheck = calc.querySelector('.pdp2-fc-puppy');
      var packsOut = calc.querySelector('.pdp2-fc-num');
      var detailOut = calc.querySelector('.pdp2-fc-detail');
      var kcalPerPack = {};
      calc.querySelectorAll('.pdp2-fc-pill[data-recipe]').forEach(function (p) {
        kcalPerPack[p.getAttribute('data-recipe')] = parseFloat(p.getAttribute('data-kcal')) || 554;
      });
      var state = {
        recipe: (calc.querySelector('.pdp2-fc-pill[data-recipe][aria-pressed="true"]') || {}).getAttribute
          ? calc.querySelector('.pdp2-fc-pill[data-recipe][aria-pressed="true"]').getAttribute('data-recipe')
          : 'beef',
        activity: parseFloat((calc.querySelector('.pdp2-fc-pill[data-activity][aria-pressed="true"]') || { getAttribute: function () { return '1.023'; } }).getAttribute('data-activity'))
      };

      function calcFeeding() {
        var lbs = parseFloat(weightInput.value) || 0;
        var kg = lbs / 2.2046;
        var rer = 70 * Math.pow(kg, 0.75);
        var kcalDay = rer * state.activity;
        if (puppyCheck && puppyCheck.checked) kcalDay *= 2.0;
        var perPack = kcalPerPack[state.recipe] || 554;
        var packsDay = kcalDay / perPack;
        var ozDay = packsDay * 16;
        packsOut.textContent = packsDay.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
        detailOut.textContent = ozDay.toFixed(1).replace(/\.0$/, '') + ' oz · ~' + Math.round(kcalDay) + ' kcal';
      }

      if (weightInput) weightInput.addEventListener('input', calcFeeding);
      if (puppyCheck) puppyCheck.addEventListener('change', calcFeeding);
      calc.querySelectorAll('.pdp2-fc-pill[data-recipe]').forEach(function (p) {
        p.addEventListener('click', function () {
          calc.querySelectorAll('.pdp2-fc-pill[data-recipe]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          p.setAttribute('aria-pressed', 'true');
          state.recipe = p.getAttribute('data-recipe');
          calcFeeding();
        });
      });
      calc.querySelectorAll('.pdp2-fc-pill[data-activity]').forEach(function (p) {
        p.addEventListener('click', function () {
          calc.querySelectorAll('.pdp2-fc-pill[data-activity]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          p.setAttribute('aria-pressed', 'true');
          state.activity = parseFloat(p.getAttribute('data-activity'));
          calcFeeding();
        });
      });
      calcFeeding();
    }

    /* ── Testimonial wall: reveal + tag filters ───────────── */
    var wallToggle = document.querySelector('.pdp2-wall-toggle');
    var wallBody = document.querySelector('.pdp2-wall-body');
    if (wallToggle && wallBody) {
      wallToggle.addEventListener('click', function () {
        var isOpen = wallBody.hidden;
        wallBody.hidden = !isOpen;
        wallToggle.setAttribute('aria-expanded', String(isOpen));
        wallToggle.textContent = isOpen
          ? wallToggle.getAttribute('data-label-open')
          : wallToggle.getAttribute('data-label-closed');
        if (isOpen) wallBody.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
      });
    }

    var wallFilters = document.querySelectorAll('.pdp2-wall-filters .pdp2-pill');
    var wallCards = document.querySelectorAll('.pdp2-wall-card');
    wallFilters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        wallFilters.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var tag = btn.getAttribute('data-tag');
        wallCards.forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').split(',');
          card.hidden = !(tag === 'all' || tags.indexOf(tag) !== -1);
        });
      });
    });
  });
})();
